

export default function CreditForm({ formData, handleInputChange,errors }) {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };

    return (
        <div>
            <h4>Credit Repair Inquiry</h4>

            {/* Improve Credit Score */}
            <div className="single-box pt_15">
                <div className="inner-title">
                    <label htmlFor="improveCredit"><p>Are you looking to improve your credit score?</p></label>
                </div>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="existingDebts1"
                            required
                            value="yes"
                            checked={formData.existingDebts1 === "yes"}
                            onChange={handleChange}
                        />
                        Yes
                    </label>
                    
                    <label>
                        <input
                            type="radio"
                            name="existingDebts1"
                            required
                            value="no"
                            checked={formData.existingDebts1 === "no"}
                            onChange={handleChange}
                        />
                    No
                </label>
                    
                </div>
                {errors.existingDebts1 && <span className="error-message">{errors.existingDebts1}</span>}
            </div>

            {/* Specific Credit Issues */}
            <div className="single-box">
                <div className="inner-title"><br></br>
                    <label htmlFor="Credit_Issue"><p>Please describe any specific credit issues you'd like to address:</p></label>
                </div>
                <input
                    type="text"
                    
                    name="Credit_Issue"
                    value={formData.Credit_Issue || ""}
                    maxLength={100}
                    onChange={handleChange}
                    required
                />
                <span className="error-message">{errors.Credit_Issue}</span>
            </div>

            {/* Checked Credit Report Recently */}
            <div className="single-box mb-10">
                <div className="inner-title">
                    <label htmlFor="checkedCreditReport"><p>Have you checked your credit report recently?</p></label>
                </div>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="appointment22"
                            required
                            value="yes"
                            checked={formData.appointment22 === "yes"}
                            onChange={handleChange}
                        />
                        Yes
                    </label>
                    <label>
                    
                        <input
                            type="radio"
                            name="appointment22"
                            required
                            value="no"
                            checked={formData.appointment22 === "no"}
                            onChange={handleChange}
                        />
                        No
                </label>
                    
                </div>
                {errors.appointment22 && <span className="error-message">{errors.appointment22}</span>}
            </div>
        </div>
    );
}
